import React, { useState, Fragment } from "react"
import { useTranslation } from "react-i18next"

import HeldOrdersListModal from "./HeldOrdersListModal"
import classes from "./index.module.scss"

const RetrieveButton = () => {
  const [openRetrievModal, setOpenRetrievModal] = useState(false)

  const [t] = useTranslation()

  return (
    <Fragment>
      <button
        className={classes["button"]}
        onClick={() => setOpenRetrievModal(true)}
      >
        {t("بازیابی")}
      </button>

      <HeldOrdersListModal
        openRetrievModal={openRetrievModal}
        setOpenRetrievModal={setOpenRetrievModal}
      />
    </Fragment>
  )
}

export default RetrieveButton